import * as yup from 'yup';
import { employmentTypeList, YesNoList } from 'contexts/FormProvider';
import { phoneNumberSchema } from 'pages/Complaint/InsuredDetails/schema';

import { validateDecimalSchema, validateTextSchema } from 'utils/commonSchema';

yup.setLocale({
  mixed: {
    oneOf: '',
    required: '',
  },
});

const textFieldMin = 1;
const textFieldMax = 200;

export const employmentSchema = yup.array().when('employmentStatus', {
  is: 'yes',
  then: () =>
    yup.array().of(
      yup.object().shape({
        id: yup.string(),

        employmentType: yup
          .string()
          .oneOf([...employmentTypeList])
          .required(),

        employerName: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

        occupation: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

        contactPerson: validateTextSchema({ minLen: 0, maxLen: textFieldMax, required: false }),

        contactPersonNumber: phoneNumberSchema(),

        salary: validateDecimalSchema({
          errorMessage: 'Please enter a valid value',
          required: true,
        }),
      })
    ),
});

const validationSchema = yup.object().shape({
  employmentStatus: yup
    .string()
    .oneOf([...YesNoList])
    .nullable()
    .required(),

  employmentData: employmentSchema,
});

export default validationSchema;
